import React, { useState, useEffect, useContext, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Notify } from '../../../components';
import SlideboxHeader from '../../../../deprecated/SlideboxHeader';
import SlideboxTabs from './SlideboxTabs';
import SlideboxListView from './SlideboxListView';
import * as slideboxAction from '../actions/slidebox-action';
import CreateDirectory from '../../../../deprecated/CreateDirectory';
import DeleteConfirm from '../../../../deprecated/DeleteConfirm';
import SharedPopup from '../../../../deprecated/SharedPopup';
import { SocketContext } from '../../../utils/serviceContext';
import GroupsSelection from '../../../../deprecated/AddToGroupPopup';
import MoveToPopUp from '../../../../deprecated/MoveToPopUp';
import Details from './SlideItems/caseDetailsOverlay/Details';
import AssignUserPopup from '../../../../deprecated/AssignUserPopup';
import * as dashBoardAction from '../../adminDashboard/actions/adminDashboard-action';
import * as globalAction from '../../../actions/global-action';
import { useOutsideClick } from '../../../utils/utils';

function SlideBoxDataSection({
  slideDirectory,
  slideDirDataList,
  showLoader,
  selectedList,
  selectedListType,
  selectedListName,
  selectedFolder,
  selectedFolderType,
  selectedFolderName,
  loadSlideboxDirDataList,
  refreshWorklistSilent,
  refreshWorklistColumnData,
  currentTab,
  deleteSlideBoxItemAction,
  setSelectedListDirectory,
  setSelectedDirCollaborators,
  setSelectedDirAssignUsers,
  setOpenListDirectory,
  isSearch,
  selectedListSlideData,
  setSelectedSlideData,
  movePopupState,
  setSlideBoxMovePopupAction,
  setSelectedListActivity,
  isListView,
  isPatientView,
  getSearchDirData,
  getUserListDataAction,
  getUserDetailsAction,
  isModal,
  getFileDownloadUrlAction,
  deselectListDirAction,
  isFolderSelected,
  setIsFolderSelected,
  when,
  setContinueButtonDisabled,
  setSelectedSlideDataToAnalyze,
  importSlide,
  selectedSlideDataToAnalyze,
  message,
  showMessage,
  resetSlideboxMessageAction,
  worklistColumnData,
  isOpenedFromGroups,
  isSearchTabActive,
  setIsSearchTabActive,
  showDetails,
  setShowDetails,
  showAdvancedSearchModal,
  getAllCaseDetailsTabsInfoAction,
}) {
  const listRef = useRef();
  const socket = useContext(SocketContext);
  const [openCreateDir, setOpenCreateDir] = useState(false);
  const [openDeleteDir, setOpenDeleteDir] = useState(false);
  const [openSharedPopup, setOpenSharedPopup] = useState(false);
  const [showGroupsSelectionPopup, setShowGroupsSelectionPopup] = useState(false);

  const [openAllContainers, setOpenAllContainers] = useState(false);
  const [outSideList, setOutSideList] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  // The case-details overlay (Details/SlidesTab) reads its slide list from a
  // separate Redux slice (state.SlideBox.allSlides) that's only populated
  // when the overlay is opened (SlideTable's handleSelectRow) — refreshWorklist
  // above doesn't touch it. Without this, a slide finishing conversion while
  // its overlay is already open never updates the visible thumbnail there
  // until the user closes and reopens it. Mirrored into refs to avoid a
  // stale closure in the socket handler below.
  const showDetailsRef = useRef(showDetails);
  const selectedDetailsRef = useRef(selectedDetails);
  // SlideTable reads from worklistColumnData (via its own Redux connect)
  // instead of dirDataList/filteredData whenever a worklist tab is active —
  // see refreshWorklistColumnData in slidebox-action.js for why. Tracked
  // in a ref for the same stale-closure reason as the two above.
  const currentTabRef = useRef(currentTab);
  useEffect(() => {
    showDetailsRef.current = showDetails;
    selectedDetailsRef.current = selectedDetails;
    currentTabRef.current = currentTab;
  }, [showDetails, selectedDetails, currentTab]);
  const [openAssignUserPopup, setOpenAssignUserPopup] = useState(false);
  const [switchView, setSwitchView] = useState(isListView);
  const [switchListView, setSwitchListView] = useState(isPatientView);
  const [filteredData, setFilteredData] = useState(slideDirDataList);
  const [label, setLabel] = useState('');
  const [radioButtonChecked, setRadioButtonChecked] = useState({});

  const [tabOption, setTabOption] = useState('slides');
  const [openNotesSection, setOpenNotesSection] = useState(false);
  const [openLabelsSection, setOpenLabelsSection] = useState(false);
  const [showCreateCaseModal, setShowCreateCaseModal] = useState(false);

  useOutsideClick(listRef, () => {
    deselectListDirAction();
    setRadioButtonChecked({});
    setShowDetails(false);
  });

  useEffect(() => {
    getUserDetailsAction();
    getUserListDataAction();
    getUserDetailsAction();
  }, []);

  // Shared by both onFileUploadDone (slide record created, upload finished —
  // this is the moment the details-panel loader placeholder becomes visible)
  // and onConversionDone (thumbnail ready). The table row's scan icon is
  // driven by slidesCount, which is already non-zero as soon as the slide
  // record exists — it shouldn't wait for conversion to finish too.
  const refreshAfterSlideEvent = () => {
    // Use refreshWorklistSilent (not refreshWorklist/loadSlideboxDirDataList)
    // so this background event doesn't toggle showLoader — SlideTable
    // renders `showLoader ? <Loader/> : <Table/>`, so doing so would flash
    // the whole table to a blank loading state on every real-time update.
    // The reducer wholesale-replaces dirDataList with whatever this call
    // returns (SET_FOLDER_DATA_LISTS is a replace, not a merge), and the
    // table visible here is always the flat "All Cases" list — so this
    // must always fetch at 'root' level regardless of selectedFolder/
    // selectedFolderType (which reflect separate, unrelated navigation
    // state, e.g. from the details panel being open for some case).
    // Fetching at 'folder'/'case' level instead would silently replace the
    // full table with just that folder's/case's subset.
    console.warn('[RT-DEBUG] refreshAfterSlideEvent fired, calling refreshWorklistSilent(root)');
    refreshWorklistSilent({
      dirId: null,
      dirType: 'root',
    });
    // SlideTable actually reads its rows from worklistColumnData (via its
    // own separate Redux connect, state.SlideBox.worklistColumnData) in
    // preference to dirDataList/filteredData whenever that data is
    // non-empty — confirmed in SlideTable.js's useSortableData call. So a
    // worklist-tab view never sees this refresh unless worklistColumnData
    // is also kept current. Uses refreshWorklistColumnData (not
    // getWorklistDataAction) specifically because that one doesn't touch
    // showLoader — two independent in-flight requests toggling the same
    // shared flag can resolve out of order and leave the table stuck
    // behind its loading spinner even after the data itself is correct.
    // currentTab's Redux initial state is {} (truthy), not null/undefined —
    // so a bare truthy check here would fire this with worklistId: undefined
    // on every real-time event before any worklist tab is ever selected.
    if (currentTabRef.current?.worklistId) {
      console.warn('[RT-DEBUG] refreshAfterSlideEvent: also refreshing worklistColumnData for worklist', currentTabRef.current.worklistId);
      refreshWorklistColumnData({ worklistId: currentTabRef.current.worklistId });
    }
    // If the case-details overlay is currently open, also refresh its
    // slide list so a slide that just appeared (or just finished converting)
    // shows up there without the user having to close and reopen the panel.
    if (showDetailsRef.current && selectedDetailsRef.current?.dirDataId) {
      getAllCaseDetailsTabsInfoAction({
        dirId: selectedDetailsRef.current.dirDataId,
        dirType: 'case',
      });
    }
  };

  // reloads slidebox when a slide finishes uploading or finishes converting
  useEffect(() => {
    getUserDetailsAction();
    socket.onFileUploadDone().subscribe(() => {
      console.warn('[RT-DEBUG] onFileUploadDone socket event RECEIVED');
      refreshAfterSlideEvent();
    });
    socket.onConversionDone().subscribe(() => {
      console.warn('[RT-DEBUG] onConversionDone socket event RECEIVED');
      refreshAfterSlideEvent();
    });
  }, []);

  useEffect(() => {
    showMessage &&
      Notify({
        value: message,
        done: () => resetSlideboxMessageAction(),
      });
  }, [showMessage]);

  // set the filtered results in filterData State
  useEffect(() => {
    console.warn('[RT-DEBUG] slideDirDataList (dirDataList) changed, syncing to filteredData', {
      length: slideDirDataList?.length,
      sample: slideDirDataList?.slice(0, 3)?.map((r) => ({ id: r.dirDataId, name: r.dirDataName, slidesCount: r.slidesCount })),
    });
    setFilteredData(slideDirDataList);
  }, [setFilteredData, slideDirDataList]);

  // showLoader was the actual root cause of an earlier bug (a race between
  // two independent API calls sharing this one flag left SlideTable stuck
  // behind its loading spinner) — log every change to confirm it settles
  // back to false and isn't getting stuck again.
  useEffect(() => {
    console.warn('[RT-DEBUG] showLoader changed to', showLoader);
  }, [showLoader]);

  // set state to declare the create directory modal is closed
  const createDirOnClose = () => {
    setOpenCreateDir(false);
  };

  // to load the contents of the folder/case entered into via Breadcrumb or ListView
  const toggleDirHandler = ({ dirId, parentDir, dirType }) => {
    setSelectedDetails({});
    const folderListId = slideDirectory.filter(
      (dirData) => dirData.dirId === dirId && dirData.caseOrFolder === dirType
    );
    loadSlideboxDirDataList({
      dirId: dirId,
      dirType: dirType ? dirType : 'root',
    });
    setOpenListDirectory({
      dirId,
      listId: folderListId.length > 0 ? folderListId[0]['listId'] : dirId,
      // Use null to avoid setOpenChildFolder crash when the case's parent folder
      // is not loaded in the sidebar tree (common in analysis mode / worklist cases)
      parentDir: null,
      dirType: dirType ? dirType : 'root',
    });

    getUserDetailsAction();
  };

  // setter function for selecting folder or case from the list view
  const setSelectedDir = ({ dirId, parentDir, dirType }) => {
    const folderListId = slideDirectory.filter(
      (dirData) => dirData.dirId === dirId && dirData.caseOrFolder === dirType
    );
    setSelectedListDirectory({
      dirId,
      listId: folderListId.length > 0 ? folderListId[0]['listId'] : dirId,
      parentDir,
      dirType: dirType,
    });

    setSelectedListActivity({
      dirId,
      dirType,
    });

    if (dirType === 'case' || dirType === 'folder') {
      setSelectedDirCollaborators({
        dirId,
        dirType: dirType,
      });
      if (dirType === 'case') {
        setSelectedDirAssignUsers({
          dirId,
          dirType: dirType,
        });
      }
      if (isModal) {
        setIsFolderSelected(true);
      }
    }

    const slideData = worklistColumnData.filter(
      (dirData) => dirData.dirDataId === dirId && dirData.caseOrFolder === 'slide'
    );
    if (isModal) {
      setIsFolderSelected(true);
    }
    setSelectedSlideData(slideData[0]);
  };

  // delete case/folder/slide modal
  const deleteDirItemPopup = (outSideListSelect = false) => {
    getUserDetailsAction();
    setOutSideList(outSideListSelect);
    setOpenDeleteDir(!openDeleteDir);
  };

  // handler for deleting case/folder/
  const handleDeleteDirItem = (e) => {
    setShowDetails(false);
    deleteSlideBoxItemAction(
      outSideList ? selectedFolderType : selectedListType,
      {
        dirId: outSideList ? selectedFolder : selectedList,
      },
      {
        onSuccess: afterDirDeleteSuccess,
        onError: afterDirDeleteFail,
      }
    );
    getUserDetailsAction();
  };

  const renameSlideItem = (outSideListSelect = false) => {
    setOutSideList(outSideListSelect);
    setOpenCreateDir(true);
  };

  const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const afterDirDeleteSuccess = () => {
    Notify({
      value: `${capitalizeFirstLetter(selectedListType)} deleted successfully`,
    });

    getUserDetailsAction();

    deleteDirItemPopup(false);
  };

  const afterDirDeleteFail = () => {
    Notify({
      value: `${capitalizeFirstLetter(selectedListType)} deletion failed`,
    });
    deleteDirItemPopup(false);
  };

  const showDirDetails = (outSideListSelect = false) => {
    getUserDetailsAction();
    setSelectedListActivity({
      dirId: selectedList,
      dirType: selectedListType,
    });
    setOutSideList(outSideListSelect);
    setShowDetails(true);
  };

  const showSharedPopup = (outSideListSelect = false) => {
    setOutSideList(outSideListSelect);
    setOpenSharedPopup(!openSharedPopup);
  };

  const handleToggleMovePopup = (outSideListSelect = false) => {
    setOutSideList(outSideListSelect);
    setSlideBoxMovePopupAction(!movePopupState);
  };

  const showGroupsSelectPopup = () => {
    setShowGroupsSelectionPopup(!showGroupsSelectionPopup);
  };

  const downloadSlide = (outSideListSelect = false) => {
    setOutSideList(outSideListSelect);
    let downloadFilePath;
    if (selectedDetails.caseOrFolder === 'slide') {
      downloadFilePath = `${selectedDetails.slidePath}/${selectedDetails.dirDataOriName}`;
    }
    if (selectedDetails.caseOrFolder === 'document') {
      downloadFilePath = selectedDetails.slidePath;
    }
    getFileDownloadUrlAction(
      { filePath: downloadFilePath },
      {
        onSuccess: downloadFile,
        onError: downloadFileFail,
      }
    );
  };

  const downloadFile = (newFileUrl) => {
    let element = document.createElement('a');
    element.setAttribute('href', newFileUrl);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadFileFail = () => {
    Notify({ value: `${selectedListType} download failed` });
  };

  const openCreateCaseModal = () => {
    setShowCreateCaseModal(!showCreateCaseModal);
  };

  return (
    <div
      className={`${
        importSlide ? 'slideboxData-container analysis-table' : 'slideboxData-container'
      }`}
      ref={listRef}
    >
      <div className="worklist-header">
        <SlideboxTabs
          setCurrentItem={setSelectedDir}
          isSearchTabActive={isSearchTabActive}
          setIsSearchTabActive={setIsSearchTabActive}
          setSelectedDetails={setSelectedDetails}
        />

        <SlideboxHeader
          {...{
            selectedList: outSideList
              ? slideDirectory.find(
                  ({ dirId, caseOrFolder }) =>
                    dirId === selectedFolder && caseOrFolder === selectedFolderType
                )
              : slideDirDataList.find(
                  ({ dirDataId, caseOrFolder }) =>
                    dirDataId === selectedList && caseOrFolder === selectedListType
                ),
            showDetails,
            setSelectedDetails,
            outSideList,
            switchView,
            setSwitchView,
            when,
          }}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', overflow: 'hidden' }}>
        <div className={`slidebar${showDetails && !showAdvancedSearchModal ? ' active' : ''}`}>
          <SlideboxListView
            setOpenAllContainers={setOpenAllContainers}
            getFileDownloadUrlAction={getFileDownloadUrlAction}
            selectedDetails={selectedDetails}
            slideDirDataList={slideDirDataList}
            showLoader={showLoader}
            toggleDirHandler={toggleDirHandler}
            setSelectedDir={setSelectedDir}
            isSearch={isSearch}
            showSharedPopup={showSharedPopup}
            deleteDirItemPopup={deleteDirItemPopup}
            renameSlideItem={renameSlideItem}
            handleToggleMovePopup={handleToggleMovePopup}
            setShowDetails={showDirDetails}
            setSelectedDetails={setSelectedDetails}
            selectedListItem={worklistColumnData.find(
              ({ dirDataId }) => dirDataId === selectedList
            )}
            showGroupsSelectPopup={showGroupsSelectPopup}
            switchView={switchView}
            setSwitchView={setSwitchView}
            switchListView={switchListView}
            setSwitchListView={setSwitchListView}
            selectedListType={selectedListType}
            selectedList={selectedList}
            selectedFolderType={selectedFolderType}
            isListView={isListView}
            downloadSlide={downloadSlide}
            filteredData={filteredData}
            isModal={isModal}
            when={when}
            setContinueButtonDisabled={setContinueButtonDisabled}
            setSelectedSlideDataToAnalyze={setSelectedSlideDataToAnalyze}
            importSlide={importSlide}
            selectedSlideDataToAnalyze={selectedSlideDataToAnalyze}
            getSearchDirData={getSearchDirData}
            setLabel={setLabel}
            radioButtonChecked={radioButtonChecked}
            setRadioButtonChecked={setRadioButtonChecked}
            tabOption={tabOption}
            setTabOption={setTabOption}
            openNotesSection={openNotesSection}
            setOpenNotesSection={setOpenNotesSection}
            openCreateCaseModal={openCreateCaseModal}
            showCreateCaseModal={showCreateCaseModal}
            setShowCreateCaseModal={setShowCreateCaseModal}
            openLabelsSection={openLabelsSection}
            setOpenLabelsSection={setOpenLabelsSection}
          />
        </div>
        {when !== 'analysis' && openCreateDir && (
          <CreateDirectory
            dirType={outSideList ? selectedFolderType : selectedListType}
            isFile={
              outSideList
                ? false
                : selectedListType === 'slide' || selectedListType === 'document'
                  ? true
                  : false
            }
            rename={true}
            onClose={createDirOnClose}
            selectedDir={{
              slideItemId: outSideList ? selectedFolder : selectedList,
              name: outSideList ? selectedFolderName : selectedListName,
            }}
            selectedFolderType={selectedFolderType}
            selectedFolder={selectedFolder}
          />
        )}
        {openDeleteDir && (
          <DeleteConfirm
            dirType={outSideList ? selectedFolderType : selectedListType}
            isFile={outSideList ? false : selectedListType ? false : true}
            handleDelete={handleDeleteDirItem}
            modalClose={() => deleteDirItemPopup(false)}
          />
        )}
        {openSharedPopup && (
          <SharedPopup
            onClose={setOpenSharedPopup}
            selectedListType={outSideList ? selectedFolderType : selectedListType}
            selectedList={outSideList ? selectedFolder : selectedList}
          />
        )}
        {openAssignUserPopup && (
          <AssignUserPopup
            onClose={setOpenAssignUserPopup}
            selectedListType={outSideList ? selectedFolderType : selectedListType}
            selectedList={outSideList ? selectedFolder : selectedList}
          />
        )}
        {showGroupsSelectionPopup && (
          <GroupsSelection
            dialogOpen={showGroupsSelectionPopup}
            onClose={showGroupsSelectPopup}
            selectedFile={selectedListSlideData}
          />
        )}
        {movePopupState && (
          <MoveToPopUp outSideList={outSideList} onClose={() => handleToggleMovePopup()} />
        )}
        {selectedDetails && (
          <Details
            {...{
              worklistColumnData,
              showDetails,
              setShowDetails,
              selectedDetails,
              selectedListItem: worklistColumnData.find(
                ({ dirDataId }) => dirDataId === selectedList
              ),
              getFileDownloadUrlAction,
              setSelectedDetails,
              setSelectedDir,
              tabOption,
              setTabOption,
              openAllContainers,
              openNotesSection,
              setOpenNotesSection,
              openLabelsSection,
              setOpenLabelsSection,
              setSelectedSlideData,
              showAdvancedSearchModal,
            }}
            isOpenedFromGroups={isOpenedFromGroups}
            isFolderSelected={isFolderSelected}
            setIsFolderSelected={setIsFolderSelected}
            notInViewer={true}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  slideDirectory: state.SlideBox.folders,
  slideDirDataList: state.SlideBox.dirDataList,
  showLoader: state.SlideBox.showLoader,
  isSearch: state.SlideBox.isSearchData,
  selectedRightClickItem: state.SlideBox.selectedRightClickItem,
  selectedListSlideData: state.SlideBox.selectedListSlideData,
  dirDataList: state.SlideBox.dirDataList,
  movePopupState: state.SlideBox.movePopupState,
  isListView: state.SlideBox.isListView,
  isPatientView: state.SlideBox.isPatientView,
  isMoveDirActive: state.SlideBox.isMoveDirActive,
  message: state.SlideBox.message,
  worklistColumnData: state.SlideBox.worklistColumnData,
  currentTab: state.SlideBox.currentTab,
  showMessage: state.SlideBox.showMessage,
  ...state.SlideBox.selectedFolderData,
  ...state.SlideBox.selectedListData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...slideboxAction, ...dashBoardAction, ...globalAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SlideBoxDataSection);
